export const T3_URL_PARAMS = {
  locale: 'locale',
  endDate: 'endDate',
  startDate: 'startDate',
  startEndDate: 'startEndDate',
  mainDashboardPageUrl: 'mainDashboardPageUrl',
  allWidgets: 'allWidgets',
  recordingsOverviewPageUrl: 'recordingsOverviewPageUrl',
  newFunnelUrl: 'newFunnelUrl',
  newHeatmapUrl: 'newHeatmapUrl',
  redirectUrl: 'redirectUrl',
};

export const WIX_MINI_URL_PARAMS = {
  predefinedTimePeriod: 'predefinedTimePeriod',
};

export const AAAS_URL_PARAMS = {
  websiteToken: 'websiteToken',
  intpcToken: 'intpcToken',
  externalWebsiteId: 'externalWebsiteId',
  allowUpgrade: 'allowUpgrade',
  upgradePackageId: 'upgradePackageId',
};

export const COMMON_URL_PARAMS = {
  pagesDashboardPageUrl: 'pagesDashboardPageUrl',
  customEventsPageUrl: 'customEventsPageUrl',
  visitorsPageUrl: 'visitorsPageUrl',
};
